// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__btrIa","bookmark":"styles_bookmark__T37Sm","saved":"styles_saved__XzdLc","notSaved":"styles_notSaved__i2EdU"};